import { globalStore } from "../../utils/globalStore";
import { InitService } from "../../utils/initService";
import type { UserInfo } from "../../types";

/**
 * 安全更新基础用户信息（昵称、邮箱、手机号等），避免覆盖权限等鉴权字段
 */
export const updateBaseInfo = (partialInfo: Partial<UserInfo> & Record<string, any>) => {
  const current = (globalStore.getUserInfo?.() as any) || {};

  const newInfo: any = {
    ...current,
    ...partialInfo,
  };

  // 始终保留已有的权限/角色信息（如果新数据里没有提供或为空）
  if (current?.permissions && (!partialInfo.permissions || (Array.isArray(partialInfo.permissions) && partialInfo.permissions.length === 0))) {
    newInfo.permissions = current.permissions;
  }
  // 如果新数据中的 roles 为空数组，保留原有的 roles（避免用空数组覆盖正确的 roles）
  if (current?.roles && (!partialInfo.roles || (Array.isArray(partialInfo.roles) && partialInfo.roles.length === 0))) {
    newInfo.roles = current.roles;
  }

  globalStore.setUserInfo(newInfo);

  // 同步更新业务层使用的 userInfo 本地存储（兼容现有读取逻辑）
  try {
    localStorage.setItem("userInfo", JSON.stringify(newInfo));
  } catch {
    // 忽略本地存储异常
  }
};

/**
 * 重新拉取用户权限/菜单等完整信息
 * 适用于切换角色、重置状态等“敏感操作”
 */
export const reloadUserAuthority = async () => {
  await InitService.initializeUserData();

  // 将最新的 userInfo 同步到 localStorage 中供其他地方读取
  const updated = InitService.getUserInfo?.();
  if (updated) {
    try {
      localStorage.setItem("userInfo", JSON.stringify(updated));
    } catch {
      // 忽略本地存储异常
    }
  }
};


